import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import ProtectedRoute from "./routes/ProtectedRoute";
import SignIn from "./views/sign-in-page/SignIn";
import PosDash from "views/pos-section/dashboard/Dashboard";
import DevDash from "views/developer-section/dashboard/Dashboard";
import "./stylesheet/style.scss";
import ForgotPassword from "views/forgot-password/ForgotPassword";
import Rollout from "views/rollout/Rollout";

const App = () => {
	return localStorage.getItem("isLoggedIn") ? (
		localStorage.getItem("user_type") === "admin" ||
		(localStorage.getItem("user_type") === "super_admin" &&
		localStorage.getItem("dashboard_type") === "admin") ? (
		<ProtectedRoute />
		
		) : localStorage.getItem("user_type") === "pos_admin" ||
		  (localStorage.getItem("user_type") === "super_admin" && localStorage.getItem("dashboard_type") === "pos") ? (
			<BrowserRouter>
				<Switch>
					<Route path="/" component={PosDash} />
				</Switch>
			</BrowserRouter>
		) : (
			localStorage.getItem("user_type") === "dev" && (
				<BrowserRouter>
					<Switch>
						<Route path="/" component={DevDash} />
					</Switch>
				</BrowserRouter>
			)
		)
	) : (
		<BrowserRouter>
			<Switch>
				<Route path="/forgot-password" exact component={ForgotPassword} />

				<Route path="/" component={SignIn} />
			</Switch>
		</BrowserRouter>
	);
};

export default App;
